import { createContext } from 'react';
import {
  CrmPush,
  CrmPushPair,
  AsynchronousOperationStatus,
} from 'crono-fe-common/types/crmPush';

// Context objects live in their own non-component module so their identity
// survives React Fast Refresh — a module mixing createContext() with
// components/hooks gets fully re-executed on hot reload, which would create
// new context instances the already-mounted provider doesn't know about.

// Data context — only exposes values that consumers actually use.
// Omitting the raw mutation data/isLoading/isError fields prevents context
// updates from propagating on every poll tick when derived data is unchanged.
export const CrmPushContext = createContext<
  | {
      refetch: () => void;
      accountPushPairs: (CrmPushPair & {
        status: AsynchronousOperationStatus;
      })[];
      prospectPushPairs: (CrmPushPair & {
        status: AsynchronousOperationStatus;
      })[];
      warnings: CrmPush[];
    }
  | undefined
>(undefined);

// Actions context — stable after mount; mutation hooks subscribe to this only
export const CrmPushActionsContext = createContext<
  { resumePolling: () => void } | undefined
>(undefined);
